import { Formik } from "formik";
import DanhSachKeHoach from "./Components/danh-sach-ke-hoach/DanhSachKeHoach";

export const QuanlyKhaoSat: React.FC = () => {
    return (
        <Formik<any> initialValues={{}} onSubmit={() => { }}>
            <div className="bg-white h-100">
                <div className="flex-1 flex flex-column">
                    <DanhSachKeHoach
                        className="h-bang-ds-phieu-khao-sat"
                    />
                </div>
            </div>
        </Formik>
    );
};

export default QuanlyKhaoSat;
